import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {OrdersService} from "../../services/orders-service.service";
import {DeliveriesAlertsService} from "../../../deliveries/services/deliveries-alerts.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {ConfirmChangeStateService} from "../../../commons/services/confirm-change-state.service";

export class editOperationCtrl implements IController {

  order: any;
  account: AccountModel;
  billingAccount: any;
  pricePlanBundle: any;
  isDuplicate: any;
  quote: any;

  private orderCopy: any;
  private operationalServiceId: any;
  private loading: any;

  /* @ngInject */
  constructor(private $delivery, private $log, private $state, private confirmChangeStateService: ConfirmChangeStateService,
              private ordersService: OrdersService, private deliveriesAlertsService: DeliveriesAlertsService,
              private deliveriesConstants, private bringozLoaderService: BringozLoaderService) {
  }

  $onInit() {
    this.operationalServiceId = _.get(this.order, 'serviceList[0].id');
    this.orderCopy = angular.copy(this.order);
    this.confirmChangeStateService.setIsEnabled(true);
  };

  ////////////////////////////////////////////////////////////////////////////

  onSubmit(order, isShouldSendSms) {
    const operationalServiceCopy = angular.copy(order.serviceList[0]);

    this.loading = true;
    this.bringozLoaderService.on();
    this.$delivery(this.operationalServiceId).$update(order.serviceList[0], {}, {sendSms: isShouldSendSms})
      .then(() => {
        // Reset transition confirmation prompt
        this.confirmChangeStateService.reset();

        this.deliveriesAlertsService.updateFieldServiceSuccess(operationalServiceCopy);
        this.$state.go(this.deliveriesConstants.redirectLinkByTextTriggerGroup.Operation,
          {id: this.operationalServiceId});
      })
      .catch((error) => {
        if (error) {
          if (error.code === 400301) {
            this.deliveriesAlertsService.outOfServiceZoneError();
          } else {
            this.deliveriesAlertsService.updateFieldServiceError();
          }
          this.$log.error('createOrderFlowError', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
        this.bringozLoaderService.off();
      });
  }

  onCancel() {
    this.$state.go(this.deliveriesConstants.redirectLinkByTextTriggerGroup.Operation, {
      id: this.operationalServiceId
    });
  }

}

angular
  .module('bringoz.admin.orders')
  .component('editOperation', {
    bindings: {
      order: '<',
      account: '<',
      billingAccount: '<',
      pricePlanBundle: '<',
      isDuplicate: '<?',
      quote: '<?'
    },
    template: require('./edit-operation.html').default,
    controller: editOperationCtrl
  });
